<button
  class="flex-centered button-outline"
  tabindex="0"
  [disabled]="disabled()"
  (click)="clicked.emit()"
  (keydown.enter)="clicked.emit()"
>
  @if (loading()) {
    <mat-spinner [diameter]="24" class="button-outline-loading"></mat-spinner>
  } @else {
    {{ label() }}
  }
</button>
